import { Outlet, useLocation } from "react-router-dom";
import * as Styles from "./styles";

export default function OrderFulfillment() {
  return (
    <Styles.Container>
      <Outlet />
    </Styles.Container>
  );
}